<nz-spin [nzSpinning]="loading" [nzTip]="loadMsg">
  
  <form [formGroup]="form" class="form" nz-form [nzLayout]="'vertical'">

    <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
      <div class="col" style="flex: 1 1 45%">

        <nz-form-item>
          <nz-form-label nzRequired nzFor="payment_date">Payment Date</nz-form-label>
          <nz-form-control nzErrorTip="Payment date is required">
            <nz-date-picker formControlName="payment_date" name="payment_date" style="width: 100%;"></nz-date-picker>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="paid_currency">Payment Currency</nz-form-label>
          <nz-form-control nzErrorTip="Paid currency is required">
            <nz-select nzShowSearch nzAllowClear formControlName="paid_currency" name="paid_currency"
              nzPlaceHolder="Select an Currency">
              <nz-option *ngFor="let curr of currencyList" [nzValue]="curr.id" [nzLabel]="curr.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label> Exchange Rate</nz-form-label>
          <nz-form-control>
            <nz-input-group [nzAddOnAfter]="addOnAfterTemplate">
              <input nz-input type="number" name="usd_currency_exchange_rate"
                formControlName="usd_currency_exchange_rate" />
            </nz-input-group>
            <ng-template #addOnAfterTemplate>
              <button nz-button nzType="text" class="converter" (click)="fetchConvertion($event)">
                <nz-icon nzType="reload" [nzSpin]="loadingConversion" nzTheme="outline" />
              </button>
            </ng-template>
          </nz-form-control>
        </nz-form-item>








      </div>
      <div class="col" style="flex: 1 1 45%">


        <nz-form-item>
          <nz-form-label nzRequired nzFor="payment_type">Payment Type</nz-form-label>
          <nz-form-control nzErrorTip="Payment type is required">
            <nz-select nzShowSearch nzAllowClear formControlName="type" name="payment_type"
              nzPlaceHolder="Select an payment type">
              <nz-option *ngFor="let pay of paymentType" [nzValue]="pay.id" [nzLabel]="pay.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label nzRequired nzFor="amount_paid_selected_currency">Paid Amount</nz-form-label>
          <nz-form-control nzErrorTip="Amount is required">
            <input nz-input type="number" name="amount_paid_selected_currency"
              formControlName="amount_paid_selected_currency" />
            <div *ngIf="showExchangeRateWarning" style="color: #faad14; font-size: 12px; margin-top: 4px;">
              You need to update the exchange rate value before proceeding.
            </div>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label nzRequired nzFor="amount_paid_usd">Amount (USD)</nz-form-label>
          <nz-form-control nzErrorTip="Amount paid usd is required">
            <input nz-input type="number" name="amount_paid_usd" style="color: #000000d9
;" formControlName="amount_paid_usd" />
          </nz-form-control>
        </nz-form-item>











      </div>
    </div>
    <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
      <div class="col" style="flex: 1 1 45%">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="status">Payment Status</nz-form-label>
          <nz-form-control nzErrorTip="Payment status is required">
            <nz-select nzShowSearch nzAllowClear formControlName="status" name="status"
              nzPlaceHolder="Select an Status">
              <nz-option *ngFor="let payment of paymentStatus" [nzValue]="payment.id"
                [nzLabel]="payment.name"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="col" style="flex: 1 1 45%">

        <nz-form-item>
          <nz-form-label nzRequired nzFor="payment_method">Payment Method</nz-form-label>
          <nz-form-control nzErrorTip="Payment method is required">
            <nz-select nzShowSearch nzAllowClear formControlName="payment_method" name="payment_method"
              nzPlaceHolder="Select an payment method">
              <nz-option *ngFor="let pay of paymentMethods" [nzValue]="pay.id" [nzLabel]="pay.name"></nz-option>
            </nz-select>
          </nz-form-control>
          <!-- <p style="color:orangered;font-size:10px;margin-top:6px"
            *ngIf="form.get('payment_method').value == 'BANK_TRANSFER'">*Kindly attach a Vendor Bank Form or fill in the
            bank details in the text box below.</p> -->
        </nz-form-item>

      </div>
    </div>
    <div class="row" style="display: flex; gap: 16px; flex-wrap: wrap">
      <div class="col" style="flex: 1 1 45%">
        <nz-form-item>
          <nz-form-label nzRequired nzFor="submission">Quotation Submission</nz-form-label>
          <nz-form-control nzErrorTip="Submission is required">
            <nz-select nzShowSearch nzAllowClear formControlName="submission" name="submission"
              nzPlaceHolder="Select an submission">
              <nz-option *ngFor="let sub of submisions" [nzValue]="sub.id"
                [nzLabel]="formatIdToFourDigits(sub.id, 'QS') + ' - ' + (sub.quotation_request_vendor_details?.vendor_details?.name || sub.vendor_details?.name || sub.name)"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div class="col" style="flex: 1 1 45%">

        <nz-form-item>
          <nz-form-label nzFor="transaction_id">Transaction ID</nz-form-label>
          <nz-form-control>
            <input nz-input formControlName="transaction_id" name="transaction_id" />
          </nz-form-control>
        </nz-form-item>

      </div>
    </div>
    <nz-form-item *ngIf="form.get('type').value != null &&form.get('type').value == 2">
      <nz-form-label nzRequired nzFor="invoice">Invoice</nz-form-label>
      <nz-form-control nzErrorTip="Invoice is required">
        <nz-select nzShowSearch nzAllowClear formControlName="invoice" name="invoice" nzPlaceHolder="Select an invoice">
          <nz-option *ngFor="let inv of invoices" [nzValue]="inv.id" [nzLabel]="inv.invoice_number"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="form.get('payment_method').value == 'PAYMENT LINK'">
      <nz-form-label nzRequired nzFor="payment_link">Payment Link</nz-form-label>
      <nz-form-control nzErrorTip="Payment link is required">
        <input nz-input formControlName="payment_link" name="payment_link" />
      </nz-form-control>
    </nz-form-item>

    <nz-divider *ngIf="showPaymentSourceSection"></nz-divider>

    <div *ngIf="showPaymentSourceSection" class="payment-source-wrap">
      <div class="payment-source-header">
        <h4>Payment Source</h4>
        <button nz-button nzType="default" (click)="openAddSourceModal()">
          <i nz-icon nzType="plus"></i>
          Add Source
        </button>
      </div>

      <nz-table
        [nzData]="paymentSourceRows"
        [nzShowPagination]="false"
        [nzBordered]="true"
        [nzSize]="'small'"
      >
        <thead>
          <tr>
            <th>Method</th>
            <th>Source</th>
            <th nzWidth="90px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of paymentSourceRows; let i = index">
            <td>{{ row.payment_method }}</td>
            <td>{{ getPaymentSourceDisplay(row) }}</td>
            <td>
              <button nz-button nzType="text" nzDanger (click)="removePaymentSourceRow(i)">
                <i nz-icon nzType="delete"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <nz-form-item>
      <nz-form-label nzFor="notes">Notes</nz-form-label>
      <nz-form-control>
        <textarea nz-input formControlName="notes" name="notes" rows="5"></textarea>
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label>Files</nz-form-label>
      <nz-form-control class="fileUpload">
        <nz-upload [nzSize]="5242880" [nzCustomRequest]="customUploadRequest" nzListType="picture"
          [nzDownload]="handleDownload" [nzBeforeUpload]="beforeUpload" (nzChange)="onUploadChange($event)"
          [(nzFileList)]="fileList">
          <!-- <button nz-button>
            <i nz-icon nzType="paper-clip"></i> Attach Files
          </button> -->
          <button nz-button (click)="downloadFile($event)">
            <i nz-icon nzType="paper-clip"></i> Attach Files
          </button>
        </nz-upload>
        <p style="font-size:10px;font-weight: 500;font-style: italic;color:grey;
          position:absolute;right:10px;top:0px"> Accepted formats: .pdf, .jpeg, .jpg etc. (Add max file size 5 MB)</p>
      </nz-form-control>
    </nz-form-item>



    <button nz-button nzType="primary" (click)="onSubmit()" [disabled]="form.invalid"> {{ payment?.data?.id ? 'Update' :
      'Create'}} </button>
  </form>
</nz-spin>

<nz-modal
  [nzVisible]="sourceModalVisible"
  nzTitle="Add Payment Source"
  [nzOkLoading]="sourceSubmitting"
  [nzCancelText]="'Cancel'"
  [nzOkText]="'Add'"
  (nzOnCancel)="closeSourceModal()"
  (nzOnOk)="addPaymentSourceRow()"
>
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="sourceForm" [nzLayout]="'vertical'">
      <nz-form-item>
        <nz-form-label nzRequired>Payment Method</nz-form-label>
        <nz-form-control nzErrorTip="Method is required">
          <nz-select
            formControlName="payment_method"
            nzPlaceHolder="Select payment method"
            [nzDisabled]="!isMixedPaymentMethod"
          >
            <nz-option nzValue="BANK_TRANSFER" nzLabel="Bank Transfer"></nz-option>
            <nz-option nzValue="CREDIT_CARD" nzLabel="Credit Card"></nz-option>
            <nz-option nzValue="UPI" nzLabel="UPI"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="sourceForm.get('payment_method')?.value === 'BANK_TRANSFER'">
        <nz-form-label nzRequired>Bank Account</nz-form-label>
        <nz-form-control nzErrorTip="Bank account is required">
          <nz-select formControlName="bank_account" nzPlaceHolder="Select bank account" [nzLoading]="sourceLoading" nzShowSearch>
            <nz-option *ngFor="let bank of accountBanks" [nzValue]="bank.id" [nzLabel]="bank.account_name + ' - ' + bank.bank_name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="sourceForm.get('payment_method')?.value === 'CREDIT_CARD'">
        <nz-form-label nzRequired>Credit Card</nz-form-label>
        <nz-form-control nzErrorTip="Credit card is required">
          <nz-select formControlName="credit_card_account" nzPlaceHolder="Select credit card" [nzLoading]="sourceLoading" nzShowSearch>
            <nz-option *ngFor="let card of accountCards" [nzValue]="card.id" [nzLabel]="card.account_name + ' - ' + card.bank_name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="sourceForm.get('payment_method')?.value === 'UPI'">
        <nz-form-label nzRequired>UPI Account</nz-form-label>
        <nz-form-control nzErrorTip="UPI account is required">
          <nz-select formControlName="upi_account" nzPlaceHolder="Select UPI account" [nzLoading]="sourceLoading" nzShowSearch>
            <nz-option *ngFor="let upi of accountUpis" [nzValue]="upi.id" [nzLabel]="upi.account_name + ' - ' + upi.upi_id"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>